import { DetailWrapper } from "../../../../../features/ui"
import { ProductDetail } from "./productDetail"

export const ProductDetailLoader = () => (
    <DetailWrapper>
        <ProductDetail />
    </DetailWrapper>
)
